export default function getGoogleMapsAddressComponent(address, addressComponentType, name = 'long_name') {
  const addressComponent = address.address_components.find((component) =>
    component.types.includes(addressComponentType))

  return addressComponent && addressComponent[name]
}


// WEBPACK FOOTER //
// ./src/utils/get-google-maps-address-component.js